import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Map } from "immutable";
import { ConfirmAction, DropDownItem } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators/index";
import api from "APP_ROOT/api";
import {
  AT_SHOP,
  GONE,
  INVENTORY,
  OUT_ON_EXCHANGE,
  REPAIR_STATUS,
  STATUS
} from "MODULES/inventories/constants";
import { ID, REFERENCE_RECORD_LINE_ITEM_TYPE } from "APP_ROOT/constants";
import { REPAIR_AWAITING_EVALUATION } from "../../../../RepairOrders/constants";

class UnShip extends React.Component {
  propTypes = {
    pushHistory: T.func.isRequired
  };

  state = {
    open: false
  };

  toggleModal = () => this.setState({ open: !this.state.open });

  unShip = () => {
    api.shipments.reversal(this.props.shipment.get(ID)).then(() => {
      this.props.pushHistory("/shipping");
    });
  };

  render() {
    return (
      <DropDownItem onClick={this.toggleModal}>
        <i className="fa fa-fw fa-ban" />
        &nbsp;UnShip
        <ConfirmAction
          onConfirm={this.unShip}
          close={this.toggleModal}
          open={this.state.open}
        >
          <strong>Heads up!</strong> Are you sure you want to undo this&nbsp;
          <strong>Shipment</strong>?
        </ConfirmAction>
      </DropDownItem>
    );
  }
}

UnShip.propTypes = {
  shipment: T.instanceOf(Map)
};

const forSalesOrdersorRepairOrders = renderIf(({ shipment }) => {
  const commissionPaid = shipment.getIn(["sales_item", "commission_paid"]);
  const isSO =
    shipment.get(REFERENCE_RECORD_LINE_ITEM_TYPE) === "SalesOrderLineItem";
  const isRO =
    shipment.get(REFERENCE_RECORD_LINE_ITEM_TYPE) === "RepairOrderLineItem";

  const isPO =
    shipment.get(REFERENCE_RECORD_LINE_ITEM_TYPE) === "PurchaseOrderLineItem";
  const repairAwaitingEval =
    shipment.get("reference_record_line_item_approval_status") ===
    REPAIR_AWAITING_EVALUATION;
  const validInventoryStatus = [GONE, OUT_ON_EXCHANGE].includes(
    shipment.getIn([INVENTORY, STATUS])
  );
  const validInventoryRepairStatus =
    shipment.getIn([INVENTORY, REPAIR_STATUS]) === AT_SHOP;
  const roShipped = shipment.get("reference_record_line_item_shipped");

  const validSOPO = (isSO || isPO) && validInventoryStatus;
  const validRO =
    (isRO && repairAwaitingEval && roShipped) ||
    (isRO && validInventoryRepairStatus);

  return (validRO || validSOPO) && !commissionPaid;
});

export default connect(undefined, { pushHistory: push })(
  forSalesOrdersorRepairOrders(UnShip)
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Actions/UnShip.jsx